import { render, staticRenderFns } from "./IncomeTable.vue?vue&type=template&id=30ec56fe"
import script from "./IncomeTable.vue?vue&type=script&lang=js"
export * from "./IncomeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports